/**
 * Treat trailing slashes like missing (e.g. /en/ → /en) so direct visits to
 * https://uido.pl/en/ still match home routes (loader, bootstrap lock, etc.).
 */
export const normalizeHomePathname = (pathname) => {
  if (pathname == null || pathname === "") return "/";
  const trimmed = pathname.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
};

export const isHomePath = (pathname) => {
  if (pathname == null) return false;
  const p = normalizeHomePathname(pathname);
  return (
    p === "/" ||
    p === "/en" ||
    p === "/home" ||
    p === "/en/home"
  );
};

/** Strip /en prefix so `/` and `/en` compare as the same route. */
export const stripLanguagePrefix = (pathname) => {
  const normalized = normalizeHomePathname(pathname);
  return normalized.replace(/^\/en(?=\/|$)/, "") || "/";
};

export const isSameRouteDifferentLanguage = (pathA, pathB) => {
  if (pathA == null || pathB == null) return false;
  return stripLanguagePrefix(pathA) === stripLanguagePrefix(pathB);
};
